import { Component } from 'react';
import PropTypes from 'prop-types';
import * as Sentry from '@sentry/browser';

export default class ErrorBoundary extends Component {
    static propTypes = {
        children: PropTypes.node.isRequired,
    };

    componentDidCatch(error, info) {
        if (process.env.REACT_APP_ENVIRONMENT === 'local') {
            console.error(error, info);
        } else {
            Sentry.captureException(error);
        }
    }

    render() {
        return this.props.children;
    }
}
